// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__xElRL","footer":"ModalInfo_footer__1T0rw"};